import Layout from "../Layout";
import Header from "../Header/Header";
import Loader from "components/Loader";
import React, { lazy, Suspense } from "react";
import { RootURLS } from "constants/in-app-urls";
import RestrictRoute from "../../../routes/RestrictRoute";
import Signup from "container/Authentication/Signup/Signup";
import ProtectedRoute from "../../../routes/ProtectedRoute";
import BuildLayout from "../LayoutHOCs/BuildLayout/BuildLayout";
import HostListenerHOC from "../HostListenerHOC/HostListenerHOC";
import SignupLayout from "../LayoutHOCs/SignupLayout/SignupLayout";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import OnboardingLayout from "../LayoutHOCs/OnboardingLayout/OnboardingLayout";
import { TokenVerification } from "container/Authentication/TokenVerification/TokenVerification";
import NavigateWithRedirect from "components/Shared/UI/NavigateWithRedirect/NavigateWithRedirect";
import { TokenVerificationV2 } from "container/Authentication/TokenVerificationV2/TokenVerificationV2";
import StandardErrorBoundary from "components/ErrorBoundaries/StandardErrorBoundary/StandardErrorBoundary";
import Login from "container/Authentication/Login/Login";
import SimulationLayout from "../LayoutHOCs/SimulationLayout/SimulationLayout";
import CustomerAnalyticsSignup from "container/Authentication/Signup/CustomerAnalyticsSignup";
import PricingPlan from "components/PricingDetails/PricingPlan";
import PricingInfo from "components/PricingDetails/PricingInfo";
import SystemGuard from "./SystemGuard";

const PlgCRM = lazy(() => import("../../../components/MFE/PLG/PLG"));
const PlgDRIVE = lazy(() => import("../../../components/MFE/PLG-DRIVE/PLG-DRIVE"));
const BuildMFE = lazy(() => import("../../../components/MFE/BuildMFE/BuildMFE"));
const Onboarding = lazy(() => import("../../../components/MFE/OnBoarding/OnBoarding"));

const router = createBrowserRouter([
    {
        path: "/",
        element: (
            <ProtectedRoute>
                <HostListenerHOC>
                    <Layout />
                </HostListenerHOC>
            </ProtectedRoute>
        ),
        children: [
            {
                // index: true,
                path: "",
                element: <NavigateWithRedirect to={`${RootURLS.ANALYZE_URL}`} />
            },
            {
                path: `${RootURLS.DRIVE_URL}/*`,
                element: (
                    <Suspense
                        fallback={
                            <div className="h-full w-full-z-50">
                                <Loader loadingText="Loading Drive..." />
                            </div>
                        }>
                        <PlgDRIVE />
                    </Suspense>
                )
            },
            {
                path: `${RootURLS.ANALYZE_URL}/*`,
                element: (
                    // #TODO: onRefresh the app should show a full screen flashscreen
                    <Suspense
                        fallback={
                            <div className="h-full w-full-z-50">
                                <Loader loadingText="Loading Analyze..." />
                            </div>
                        }>
                        <SystemGuard>
                          <PlgCRM />
                        </SystemGuard>
                    </Suspense>
                )
            },
            {
                path: `${RootURLS.BUILD_URL}/*`,
                element: (
                    <Suspense fallback={<Loader />}>
                        <BuildLayout>
                            <BuildMFE />
                        </BuildLayout>
                    </Suspense>
                )
            }
        ]
    },
    {
        path: `${RootURLS.ON_BOARDING_URL}/*`,
        element: (
            <StandardErrorBoundary>
                <Suspense fallback={<Loader />}>
                    <OnboardingLayout>
                        <Onboarding />
                    </OnboardingLayout>
                </Suspense>
            </StandardErrorBoundary>
        )
    },
    {
        path: "/customer-analytics/pricing",
        element: <PricingPlan />
    },
    {
        path: "/customer-analytics/pricing-plan",
        element: <PricingInfo />
    },
    {
        path: `${RootURLS.INVIATION_SIMULATION_BOARDING_URL}/*`,
        element: (
            <StandardErrorBoundary>
                <Suspense fallback={<Loader />}>
                    <SimulationLayout />
                </Suspense>
            </StandardErrorBoundary>
        )
    },
    {
        path: "/auth",
        children: [
            {
                element: <RestrictRoute />,
                children: [
                    {
                        path: "customer-analytics/sign-up",
                        element: <SignupLayout header={<Header />} signup={<CustomerAnalyticsSignup />} />
                    }
                ]
            },
            {
                element: <RestrictRoute />,
                children: [
                    {
                        path: "sign-up",
                        element: <SignupLayout header={<Header />} signup={<Signup />} />
                    }
                ]
            },
            {
                element: <RestrictRoute />,
                children: [
                    {
                        path: "login",
                        element: <SignupLayout header={<Header />} signup={<Login />} />
                    }
                ]
            },
            {
                path: "verify",
                element: <TokenVerification />
            },
            {
                path: "verifyv1",
                element: <TokenVerificationV2 />
            }
        ]
    }
]);

type Props = {};

export default function RouteContainer({}: Props) {
    return (
        <>
            <RouterProvider router={router} />
        </>
    );
}
